import React from 'react';
import Style from './Skills.module.css';
import { Row, Col } from 'react-bootstrap';
import Stack from '../../../components/stackimages/Stack';
// import { Progress } from "@chakra-ui/react"
import { Link } from 'react-router-dom';

function SkillsPage() {
  return (
    <div className={Style.body}>
      <div className={Style.title}>Skills & Experience</div>
      <Row>
        <Col sm={8}>
          <div className={Style.subtitle}>
            - The main area of my expertise is front end development(client side
            for web and mobile application)
            <br /> - I use the react framework ,customer CSS, HTML,Modern day
            JavaScript,Animation,custom plugins and libraries for building
            interactive and responsive web pages attention. I have also explored
            node-js,firebass,mongodb and express.
            <br /> - I design web and mobile interfaces using FIGMA with
            prototyping of designs. I have a good eye for designs keeping the
            user experience as priority
            <br />- I have worked on private ,public and personal projects with
            - years of hands-on experience with APIs .
          </div>
          <div className={Style.subtitle}>
            Click on the link{' '}
            <Link
              className={Style.resume}
              to='/files/AdedayoResume.pdf'
              target='_blank'
              download>
              {' '}
              MyResume
            </Link>{' '}
            to download my cv and see more about my educational background
          </div>
        </Col>
        <Col className={Style.spacecol}>
          <Stack />
          {/* <Progress size="xs" isIndeterminate colorScheme="pink" /> */}
        </Col>
      </Row>
    </div>
  );
}

export default SkillsPage;
